import {
  ROLE_PLATFORM_HIXME_ADMIN,
  ROLE_CLIENT_ADMIN,
  ROLE_BROKER,
} from '@hixme/role-policy'
import authOnEnter from 'enrollment-platform/authOnEnter'
import PageWrapper from 'enrollment-platform/PageWrapper'
import BenchmarkPlans from './BenchmarkPlans'
import { BENCHMARK_PLANS } from './paths'

const BenchmarkPlansRoute = {
  path: BENCHMARK_PLANS,
  component: PageWrapper,
  onEnter(
    _nextState: unknown,
    _replace: unknown,
    callback: (err?: unknown) => void
  ) {
    authOnEnter({
      allowedRoles: [ROLE_PLATFORM_HIXME_ADMIN, ROLE_CLIENT_ADMIN, ROLE_BROKER],
      callback,
    })
  },
  indexRoute: {
    component: BenchmarkPlans,
  },
}

export default BenchmarkPlansRoute
